import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import Seo from '../components/seo';
import styles from '../styles/Blog.module.css';

export default function Blog() {
  // Always call hooks at the top
  useEffect(() => { 
    window.scrollTo(0, 0); 
  }, []);

  return (
    <main className={styles.page}>
      <Seo 
        title="B2B Outreach Blog | InviteEngine" 
        description="Expert insights on scaling your sales pipeline and outreach strategy." 
        path="/blog" 
      />

      {/* ─── PAGE HEADER (HERO) ─── */}
      <header className={styles.pageHero}>
        <div className={styles.pageHeroBg} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <nav className={styles.breadcrumb}>
            <Link to="/">HOME</Link> / BLOG
          </nav>
          <h1 className={styles.pageTitle}>
            Engineered <span className={styles.accent}>Growth</span>
          </h1>
          <p className={styles.pageSubtitle}>
            Playbooks and perspectives to help SMBs build authentic, high-converting sales pipelines.
          </p>
        </div>
      </header>

      {/* ─── ALL POSTS GRID ─── */}
      <section className={styles.feedSection}>
        <div className="container">
          <div className="row g-5">
            {posts.map((post) => (
              <div className="col-lg-6 col-xl-4" key={post.id}>
                <article className={styles.blogCard}>
                  <div className={styles.imageWrapper}>
                    {/* Featured Image */}
                    <img src={post.image} alt={post.title} className={styles.cardImg} />
                    
                    {/* Floating Category Badge */}
                    <span className={styles.badge}>{post.category}</span>
                  </div>

                  <div className={styles.cardBody}>
                    <div className={styles.meta}>
                      {post.date} • {post.readTime}
                    </div>
                    
                    <h2 className={styles.cardTitle}>
                      <Link to={`/blog/${post.id}`}>{post.title}</Link>
                    </h2>
                    
                    <p className={styles.cardExcerpt}>{post.excerpt}</p>
                    
                    <Link to={`/blog/${post.id}`} className={styles.arrowLink}>
                      Read Full Article <span className={styles.arrow}>→</span>
                    </Link>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}